import "../../App.css";

import "../../App.css";
import barra_1 from "../../img/svg/barra_1.svg";

import check_ from "../../img/svg/check-circle.svg";
import barra_2 from "../../img/svg/barra_2.svg";

import barra_txt from "../../img/svg/barra_txt.svg";
import icn_1 from "../../img/svg/icn_1.svg";
import icn_2 from "../../img/svg/icn_2.svg";
import icn_3 from "../../img/svg/icn_3.svg";
import check from "../../img/svg/check-solid.svg";
import check_mark from "../../img/check.gif";
import spiner from "../../img/spiner.gif";
import phone from "../../img/svg/telephone-forward.svg";

import youtube from "../../img/svg/youtube.svg";
import linkedin from "../../img/svg/linkedin.svg";
import facebook from "../../img/svg/facebook.svg";
import instagram from "../../img/svg/instagram.svg";
import arrow from "../../img/svg/arrow-repeat.svg";
import guarantee from "../../img/guarantee.gif";
import mundo from "../../img/mundo.gif";
import contador from "../../img/contador.gif";
import unab from "../../img/svg/unab.svg";
import axios from "axios";

import { Carousel, CarouselItem } from "reactstrap";

import { useEffect, useState } from "react";
import Loader from "../loader/loader";

import APIS from "../../services/apis";

function Step6({
  setPage,
  valor_matricula_anual,
  valor_arancel_anual,
  valor_beca_matricula_unab,
  valor_beca_arancel_unab,
  valor_matricula_anual_unab,
  valor_anual_con_becas,
  valor_mensual_con_becas,
  valor_sede,
  valor_nombre_carrera,
  certificado,
  caracteristica_1,
  caracteristica_2,
  caracteristica_3,
  downseling,
  setNuevaSimulacion,
  loadingFinal,
  setLoadingFinal,
  permitir_envio,
  jwt
}) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [certificadoEnviado, setCertificadoEnviado] = useState(false);
  const [loadingCertif, setLoadingCertif] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === downseling.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === 0 ? downseling.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const slides = downseling.map((d, index) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={index}
      >
        <div class="card py-4 card_downselling">
          <div class="thingy">
            <div class="head maxwidth2">
              <div class="big titular text--center color--color3">
                <p
                  style={{
                    fontSize: "125%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <svg
                    onClick={previous}
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    fill="#1e75db"
                    class="bi bi-arrow-left-circle-fill arrow"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z" />
                  </svg>
                  <strong className="card_downselling_title">
                    {d.simulacion.nombre_carrera}
                  </strong>
                  <svg
                    onClick={next}
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    fill="#1e75db"
                    class="bi bi-arrow-right-circle-fill arrow"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                  </svg>
                </p>
                <p class="sede sede_subtitle carrera--sede">
                  Sede {d.simulacion.sede}
                </p>
              </div>
            </div>
            <div class="maxwidth2 table ">
              <div class="text--center">
                <h3 class="special color--color2">Precio regular</h3>
              </div>
              <table class="medium">
                <tbody>
                  <tr>
                    <td>Valor matrícula</td>
                    <td>
                      <span class="tachado">
                        $
                        {d.informacion_financiera.valor_matricula_anual.toLocaleString(
                          "es"
                        )}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>Valor anual</td>
                    <td>
                      <span class="tachado">
                        $
                        {d.informacion_financiera.valor_arancel_anual.toLocaleString(
                          "es"
                        )}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="maxwidth2 table">
              <div class="text--center">
                <h3 class="special color--color2">Descuentos</h3>
              </div>
              <table class="medium titular">
                <tbody>
                  <tr class="color--color3">
                    <td>
                      <i class="fas fa-check"></i>Beneficio Matrícula UNAB*
                      <div class="small">
                        <span class="icn">-</span>
                        <span>
                          * Aplica solo si seleccionas la carrera{" "}
                          <strong>UNAB como primera preferencia</strong>.
                        </span>
                      </div>
                    </td>
                    <td>
                      -$
                      {d.informacion_financiera.valor_beca_matricula_unab.toLocaleString(
                        "es"
                      )}
                    </td>
                  </tr>
                  {d.informacion_financiera.valor_beca_arancel_unab ? (
                    <>
                      <tr class="color--color3">
                        <td>
                          <i class="fas fa-check"></i>
                          Beneficio arancel UNAB
                          <div class="small">
                            Descuento anual sobre el valor de la carrera
                          </div>
                        </td>
                        <td>
                          -$
                          {d.informacion_financiera.valor_beca_arancel_unab.toLocaleString(
                            "es"
                          )}
                        </td>
                      </tr>
                    </>
                  ) : (
                    <>
                      <tr class="color--color3">
                        <td>
                          <i class="fas fa-check"></i>
                          <div class="small"></div>
                        </td>
                        <td></td>
                      </tr>
                    </>
                  )}
                </tbody>
              </table>
            </div>
            <div class="maxwidth2 table bg--color4 color--color1 footer_downselling ">
              <div class="ttl text--center">
                <h3 class="special color--color1">Total a pagar</h3>
              </div>
              <table class="big titular">
                <tbody>
                  <tr>
                    <td>Matrícula con Beneficio</td>
                    <td>$0</td>
                  </tr>
                  <tr>
                    <td>Valor carrera anual con Beneficio</td>
                    <td>
                      $
                      {d.informacion_financiera.valor_anual_con_becas.toLocaleString(
                        "es"
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Valor carrera mensual con Beneficio
                      <div class="small">
                        Calculado en{" "}
                        {downseling[0].informacion_financiera.cantidad_cuotas}{" "}
                        cuotas
                      </div>
                    </td>
                    <td>
                      $
                      {d.informacion_financiera.valor_mensual_con_becas.toLocaleString(
                        "es"
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </CarouselItem>
    );
  });

  useEffect(() => {
    next();
  }, []);

  const caracteristicasImg = [guarantee, mundo, contador];

  const certificadoGet = () => {
    //vespertino/certificado/enviar/{idCertificado}

    APIS.sendCertificado({}, certificado, jwt)
      .then((res) => {
        alert("Se envió el certificado Correctamente");
        setCertificadoEnviado(true);
        setLoadingCertif(false);

      })
      .catch(function (error) {
        console.error(error);
        alert("No se pudo enviar el certificado, intente nuevamente.");
      });
  };
  return (
    <section className="result_">
      {loadingFinal ? (
        <>
          <Loader />
        </>
      ) : (
        <>
          {certificadoEnviado ? (
            <div className="result_wrapper">
              <div className="result_enviado">
                <div className="result_box">
                  <div className="center_title mark_box">
                    <img alt="" className="check_mark" src={check_mark} />
                  </div>

                  <div class="center_title result_title1">
                    <h3 className="title_4">Felicitaciones</h3>
                  </div>
                  <div class="center_title">
                    <h3 className="title_5">
                      Tu postulación ha sido enviada con éxito
                    </h3>
                  </div>
                  <h4 class="center_title desc_result">
                    Te contactaremos telefónicamente dentro de las próximas
                    horas para contarte sobre la carrera y resolver tus dudas
                  </h4>
                </div>
              </div>
              <div className="result_footer">
                <div class="padded has--bg bg--color10 text--center p-2">
                  <div
                    className="button medium--2"
                    onClick={() => {
                      setNuevaSimulacion(true);
                      setPage(3);
                      setLoadingFinal(true);
                      setCertificadoEnviado(false);
                    }}
                  >
                    <a class="border retry">
                      <div className="bold_letter color--color1 repeat">
                        Volver a simular
                        <img alt="" className="repeat_icon" src={arrow} />
                      </div>
                    </a>
                  </div>
                </div>

                <div class="final_social padded2 bg--color6">
                  <div class="maxwidth text--center">
                    <div class="cols cols3">
                      <div className="col col1">
                        <img alt="" src={unab} />
                      </div>
                      <div class="col col1">
                        <h4 class="color--color7">¿Tienes dudas?</h4>
                        <div class="buttons">
                          <a class="button">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="26"
                              height="26"
                              fill="currentColor"
                              class="bi bi-whatsapp blue_circle_wsp"
                              viewBox="0 0 16 16"
                            >
                              <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
                            </svg>
                            <div class="color--color4 icon_text">WhatsApp</div>
                          </a>
                          <a class="button">
                            <div className="blue_circle_wsp">
                              <img
                                className="blue_circle_phone"
                                src={phone}
                                alt=""
                              />
                            </div>
                            <div class="color--color4 icon_text">
                              600 228 6262
                            </div>
                          </a>
                        </div>
                        <p class="small color--color4">
                          Horario de atención Lunes a Viernes de 09:00 a 20:00
                          hrs
                        </p>
                      </div>
                      <div class="col col1">
                        <h4 class="color--color7">Síguenos en</h4>
                        <div class="buttons">
                          <a
                            class="button"
                            href="https://www.linkedin.com/groups/4510164/"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <div className="blue_circle_wsp">
                              <img
                                className="blue_circle_social"
                                src={linkedin}
                                alt=""
                              />
                            </div>
                          </a>
                          <a
                            class="button"
                            href="https://www.youtube.com/c/unabtv"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <div className="blue_circle_wsp">
                              <img
                                className="blue_circle_social"
                                src={youtube}
                                alt=""
                              />
                            </div>
                          </a>
                          <a
                            class="button"
                            href="https://www.instagram.com/advanceunab/"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <div className="blue_circle_wsp">
                              <img
                                className="blue_circle_social"
                                src={instagram}
                                alt=""
                              />
                            </div>
                          </a>
                          <a
                            class="button"
                            href="https://www.facebook.com/advance.unab.cl"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <div className="blue_circle_wsp">
                              <img
                                className="blue_circle_social"
                                src={facebook}
                                alt=""
                              />
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <>
              <div class="in">
                <header class="marquee bg--color6">
                  <div class="in">
                    <div class="maxwidth">
                      <div class="logo"></div>
                      <div class="ttl final_title">
                        <h2 className="color_header">Resultados</h2>
                      </div>
                      <div class="air gone"></div>
                    </div>
                  </div>
                </header>
                <main id="content-result" className="final_section">
                  <div class="bg--color6 padded--left padded--right">
                    <div class="maxwidth2">
                      <div className="ttl big titular text--center color--color4 ">
                        <p className="final_title2">
                          Estos son los{" "}
                          <strong className="bold_letter">
                            Valores y beneficios para ti
                          </strong>
                        </p>
                      </div>
                      <div class="text--center" style={{ marginTop: 1 + "em" }}>
                        <h3 class="final_subtitle special color--color4">
                          <strong className="bold_letter">
                            {valor_nombre_carrera}
                          </strong>
                          <br />
                          {valor_sede !== "Online" ? (
                            <>
                              <span class="user--sede">{valor_sede}</span>
                            </>
                          ) : null}
                        </h3>
                      </div>
                    </div>
                    <div id="tablas" class="maxwidth space--up padded--leftt">
                      <div class="cols cols2 stretched">
                        <div class="col col1">
                          <div class="bg--color1 padded">
                            <div class="table blue_table">
                              <div class="text--center">
                                <h3 class="special color--color2">
                                  Valor regular
                                </h3>
                              </div>
                              <table class="medium--2 ">
                                <tbody>
                                  <tr>
                                    <td>Valor matrícula</td>
                                    <td>
                                      <span class="tachado">
                                        $
                                        {valor_matricula_anual.toLocaleString(
                                          "es"
                                        )}
                                      </span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Valor anual</td>
                                    <td>
                                      <span class="tachado">
                                        $
                                        {valor_arancel_anual.toLocaleString(
                                          "es"
                                        )}
                                      </span>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div class="table">
                              <div class="text--center">
                                <h3 class="special color_color10">
                                  Descuentos
                                </h3>
                              </div>
                              <table class="medium--2">
                                <tbody>
                                  <tr class="color_color10">
                                    <td>
                                      <div className="label_discount">
                                        <img
                                          alt=""
                                          src={check}
                                          className="check_"
                                        />
                                      </div>
                                      Mátricula gratis
                                    </td>
                                    <td>
                                      <span className="label_discount ">
                                        -$
                                        {valor_beca_matricula_unab.toLocaleString(
                                          "es"
                                        )}
                                      </span>
                                    </td>
                                  </tr>
                                  {valor_beca_arancel_unab > 0 ? (
                                    <>
                                      <tr class="color_color10">
                                        <td>
                                          <div className="label_discount">
                                            <img
                                              alt=""
                                              src={check}
                                              className="check_"
                                            />
                                          </div>
                                          Beca arancel anual UNAB
                                        </td>
                                        <td>
                                          <span className="label_discount ">
                                            -$
                                            {valor_beca_arancel_unab.toLocaleString(
                                              "es"
                                            )}
                                          </span>
                                        </td>
                                      </tr>
                                    </>
                                  ) : null}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div class="col col1">
                          <div class="bg--color4 color--color1 padded color_card">
                            <div class="table ">
                              <div class="ttl text--center">
                                <div>
                                  <h3 class="special color--color1">
                                    Total a pagar
                                  </h3>
                                </div>
                              </div>
                              <table class="medium--2">
                                <tbody className="color--1-text">
                                  <tr>
                                    <td>
                                      Matrícula anual
                                      <div class="small">
                                        GRATIS POR DURACIÓN FORMAL DE CARRERA
                                      </div>
                                    </td>
                                    <td>$0</td>
                                  </tr>
                                  <tr>
                                    <td>Valor carrera anual con Beneficio</td>
                                    <td>
                                      $
                                      {valor_anual_con_becas.toLocaleString(
                                        "es"
                                      )}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      Valor carrera mensual con Beneficio
                                      <div class="small">
                                        Calculado en 11 cuotas
                                      </div>
                                    </td>
                                    <td>
                                      <span>
                                        $
                                        {valor_mensual_con_becas.toLocaleString(
                                          "es"
                                        )}
                                      </span>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <i class="clear"></i>
                      </div>
                    </div>
                    <div class="maxwidth2 titular text--center padded">
                      {permitir_envio && (
                        <div class="cols cols3">
                          <div class="col col1"></div>
                          <div class="col col1">
                            <div class="icn color--color3">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="70"
                                height="70"
                                fill="currentColor"
                                class="bi bi-envelope"
                                viewBox="0 0 16 16"
                              >
                                <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" />
                              </svg>
                            </div>
                            <div class="button medium--2">
                              <a
                                class="bg--color4 color--1-text bold_letter certif_button "
                                href="#"
                                onClick={() => {
                                  setLoadingCertif(true);
                                  certificadoGet();
                                }}
                              >
                                <p>
                                  {loadingCertif ? (
                                    <>
                                      <img
                                        alt="loading"
                                        className="spiner"
                                        src={spiner}
                                      />
                                    </>
                                  ) : (
                                    <>Enviar a mi e-mail</>
                                  )}
                                </p>
                              </a>
                            </div>
                          </div>
                          <div class="col col1"></div>
                          <span class="clear"></span>
                        </div>
                      )}
                    </div>
                  </div>

                  <div class="has--bg bg--color1 color--color2 ">
                    <div class="section--bg img--bg-o "></div>
                    <div class="in in_ padded">
                      <div class="maxwidth">
                        <div class="center_title">
                          <h3 className="title_4">Ventajas de estudiar</h3>
                        </div>
                        <div class="center_title">
                          <h3 className="title_5">Advance</h3>
                        </div>
                        <div class="cols cols3 center_div">
                          <div class="col col1 box_flex">
                            <div class="in box_flex">
                              <img
                                class=" icon_center"
                                src={caracteristicasImg[0]}
                                alt=""
                              />
                              <div class="texts">
                                <p>{caracteristica_1}</p>
                              </div>
                            </div>
                          </div>

                          <div class="col col1 box_flex">
                            <div class="in box_flex">
                              <img
                                class=" icon_center"
                                src={caracteristicasImg[1]}
                                alt=""
                              />
                              <div class="texts">
                                <p>{caracteristica_2}</p>
                              </div>
                            </div>
                          </div>

                          <div class="col col1 box_flex">
                            <div class="in box_flex">
                              <img
                                class=" icon_center"
                                src={caracteristicasImg[2]}
                                alt=""
                              />
                              <div class="texts">
                                <p>{caracteristica_3}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="relative style--1 padded--left  padded--right">
                    <div class="in">
                      <div class="maxwidth2" style={{ marginTop: 2 + "em" }}>
                        <div class="ttl big titular text--center title_options">
                          <span>¿No te decides?</span>{" "}
                          <strong className="bold_letter">
                            Mira estas opciones
                          </strong>
                        </div>
                      </div>
                      <div class="maxwidth space--up">
                        <div class="cards_holder">
                          <Carousel
                            activeIndex={activeIndex}
                            next={next}
                            previous={previous}
                            interval={4000} // set the interval to 5 seconds
                          >
                            {slides}
                          </Carousel>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="padded has--bg bg--color10 text--center p-2">
                    <div
                      className="button medium--2"
                      onClick={() => {
                        setNuevaSimulacion(true);
                        setPage(3);
                        setLoadingFinal(true);
                        setCertificadoEnviado(false);
                      }}
                    >
                      <a class="border retry">
                        <div className="bold_letter color--color1 repeat">
                          Volver a simular
                          <img alt="" className="repeat_icon" src={arrow} />
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="final_social padded bg--color6">
                    <div class="maxwidth text--center">
                      <div class="cols cols3">
                        <div className="col col1">
                          <img alt="" src={unab} />
                        </div>
                        <div class="col col1">
                          <h4 class="color--color7">¿Tienes dudas?</h4>
                          <div class="buttons">
                            <a class="button" href="https://api.whatsapp.com/send?phone=56946171786">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="26"
                                height="26"
                                fill="currentColor"
                                class="bi bi-whatsapp blue_circle_wsp"
                                viewBox="0 0 16 16"
                              >
                                <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
                              </svg>
                              <div class="color--color4 icon_text">
                                WhatsApp
                              </div>
                            </a>
                            <a class="button" href="https://api.whatsapp.com/send?phone=56946171786">
                              <div className="blue_circle_wsp">
                                <img
                                  className="blue_circle_phone"
                                  src={phone}
                                  alt=""
                                />
                              </div>
                              <div class="color--color4 icon_text">
                                600 228 6262
                              </div>
                            </a>
                          </div>
                          <p class="small color--color4">
                            Horario de atención Lunes a Viernes de 09:00 a 20:00
                            hrs
                          </p>
                        </div>
                        <div class="col col1">
                          <h4 class="color--color7">Síguenos en</h4>
                          <div class="buttons">
                            <a
                              class="button"
                              href="https://www.linkedin.com/groups/4510164/"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <div className="blue_circle_wsp">
                                <img
                                  className="blue_circle_social"
                                  src={linkedin}
                                  alt=""
                                />
                              </div>
                            </a>
                            <a
                              class="button"
                              href="https://www.youtube.com/c/unabtv"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <div className="blue_circle_wsp">
                                <img
                                  className="blue_circle_social"
                                  src={youtube}
                                  alt=""
                                />
                              </div>
                            </a>
                            <a
                              class="button"
                              href="https://www.instagram.com/advanceunab/"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <div className="blue_circle_wsp">
                                <img
                                  className="blue_circle_social"
                                  src={instagram}
                                  alt=""
                                />
                              </div>
                            </a>
                            <a
                              class="button"
                              href="https://www.facebook.com/advance.unab.cl"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <div className="blue_circle_wsp">
                                <img
                                  className="blue_circle_social"
                                  src={facebook}
                                  alt=""
                                />
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </main>
              </div>
            </>
          )}
        </>
      )}
    </section>
  );
}

export default Step6;
